import { render, staticRenderFns } from "./AuthorUpload.vue?vue&type=template&id=16c124d6"
import script from "./AuthorUpload.vue?vue&type=script&lang=js"
export * from "./AuthorUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports